import { useContext } from 'react';
import { FlagshipContext, useFlagship } from '@flagship.io/react-sdk';

export const useExperiment = (key, defaultValue) => {
  const { state } = useContext(FlagshipContext);
  const { getFlag } = useFlagship();

  /*
    Return the defaultValue instead of relying on the Flagship API to do so.
    This avoids getFlag logging a warning when the visitor is not ready or when the flag is not found.
  */
  if (!state.visitor && !state.modifications?.has(key)) {
    return { value: defaultValue };
  }

  const flag = getFlag(key, defaultValue);
  return { value: flag.getValue() };
};
